<template>
	<span class="toast" v-show="show">{{ text }}</span>
</template>

<script>
export default {
	props: {
		value: Boolean,
		time: {
			type: Number,
			default: 2000
		},
		text: String
	},
	data () {
		return {
			show: this.value
		}
	},
	created () {
		if (this.value) {
			this.show = true
		}
	},
	watch: {
		show (val) {
			if (val) {
				this.$emit('input', true)
				clearTimeout(this.timeout)
				this.timeout = setTimeout(() => {
					this.show = false
					this.$emit('input', false)
				}, this.time)
			}
		},
		value(val) {
			this.show = val
		}
	}
}
</script>

<style lang="scss" scope>
@import "../../assets/css/public.scss";
.toast {
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	display: inline-block;
	padding: 8px 20px;
	border-radius: 6px;
	background-color: rgba(0,0,0,.7);
	color: #fff;
	font-size: 14;
	text-align: center;
	z-index: 100000;
}
</style>



// WEBPACK FOOTER //
// Toast.vue?32ce8b54